var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-content",class:{'hidden-xs-up': !_vm.open},attrs:{"id":_vm.id}},[_c('header',{staticClass:"mobile-header align-items-center p-6 bg-body text-green-light"},[_c('h2',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('span',{staticClass:"icon-cancel pl-5 ml-auto",on:{"click":_vm.closeTab}})]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-037f9922","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/TabContent.vue
// module id = tXrt
// module chunks = 0